import { render, staticRenderFns } from "./MessageProtect.vue?vue&type=template&id=314dc2aa&scoped=true"
import script from "./MessageProtect.vue?vue&type=script&lang=ts"
export * from "./MessageProtect.vue?vue&type=script&lang=ts"
import style0 from "./MessageProtect.vue?vue&type=style&index=0&id=314dc2aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314dc2aa",
  null
  
)

export default component.exports